import { ButtonDanger, ButtonSecondary } from '@ui/button';
import { ModalDialog } from '@ui/modal-dialog';
import { useStore } from '@lib/state-engine';
import {
  $cannotRemoveVisible,
  $modalVisible,
  $successModalVisible,
  $warehouse,
  closeSubmit,
  closeCannotRemove,
  closeSuccess,
  remove,
  submit,
  $errorModalVisible,
  closeError,
  $pending,
} from './model';
import { IWarehouse } from '@@/warehouses/ts';

export function RemoveWarehouse(props: IRemoveWarehouseProps) {
  const { id } = props;
  const wh = useStore($warehouse);
  const confirmationVisible = useStore($modalVisible);
  const cannotRemove = useStore($cannotRemoveVisible);
  const success = useStore($successModalVisible);
  const error = useStore($errorModalVisible);
  const pendingDelete = useStore($pending);

  return (
    <>
      <ButtonDanger onClick={() => remove(id)}>Удалить склад</ButtonDanger>
      {confirmationVisible && (
        <ModalDialog
          title={`Вы точно хотите удалить склад "${wh?.name}"?`}
          onClose={() => !pendingDelete && closeSubmit()}
          actions={
            <>
              <ButtonDanger disabled={pendingDelete} onClick={() => submit()}>
                Удалить
              </ButtonDanger>
              <ButtonSecondary
                disabled={pendingDelete}
                label="Отмена"
                onClick={() => closeSubmit()}
              />
            </>
          }
        >
          Отменить действие будет нельзя!
        </ModalDialog>
      )}
      {cannotRemove && (
        <ModalDialog
          title={`Склад "${wh?.name}" не может быть удален`}
          onClose={() => closeCannotRemove()}
        >
          На складе имеются заполненные хранилища: {wh?.filledBags} шт
        </ModalDialog>
      )}
      {success && (
        <ModalDialog
          title={`Склад "${wh?.name}" удален`}
          onClose={() => closeSuccess()}
        >
          Склад успешно удален
        </ModalDialog>
      )}
      {error && (
        <ModalDialog
          title={`Склад "${wh?.name}" не был удален`}
          onClose={() => closeError()}
        >
          Произошла ошибка при удалении склада!
        </ModalDialog>
      )}
    </>
  );
}

export interface IRemoveWarehouseProps {
  id: IWarehouse['id'];
}
